import styles from './Notification.module.css'

export default function Notification(props) {
    return <div className={props.value === null || props.value === 0 ? styles.notificationNone : styles.notification}>
        <div style={{ alignSelf: 'center' }}>{props.value === null || props.value === 0 ? null : props.value}</div>
    </div>
}